import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Creators as FaqCreators } from '../../store/ducks/faq';
import Loading from '../../components/Loading';

class Faq extends Component {
  static propTypes = {
    getFaqRequest: PropTypes.func.isRequired,
    faq: PropTypes.string.isRequired,
  };

  componentWillMount() {
    this.props.getFaqRequest();
  }

  render() {
    if (this.props.faq.loading) {
      return <Loading />;
    }

    return (
      <Fragment>
        <div
          className="text-box text-justify"
          dangerouslySetInnerHTML={{ __html: this.props.faq.faq }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  faq: state.faq,
});

const mapDispatchToProps = dispatch => bindActionCreators(FaqCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Faq);



// WEBPACK FOOTER //
// ./src/pages/faq/index.js